module.exports.fluidSlotDefinitions = [
  {
    id: 'article-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: true
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 1,
            ratio_height: 1,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'courier-home-news-block-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: false
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'category-news-block-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: false
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'ev-home-top-story-with-sections-sidebar-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: true
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'ev-blocks-vertical-list-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: true
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'ev-category-post-list-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: true
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
  {
    id: 'premium-block-sidebar-native-slot',
    mediaTypes: {
      native: {
        sendTargetingKeys: false,
        title: {
          required: true
        },
        body: {
          required: true
        },
        image: {
          required: true,
          aspect_ratios: [ {
            ratio_width: 3,
            ratio_height: 2,
          } ]
        },
        sponsoredBy: {
          required: true
        },
        icon: {
          required: false
        },
        clickUrl: {
          required: true
        },
      }
    }
  },
];